import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface MarketStatusState {
  isMarketOpen: boolean;
  isRepoOperationOpen: boolean;
  isHolidayToday: boolean;
  marketCanOperateT1Today: boolean;
  nextBusinessDay: string;
  followingBusinessDay: string;
}

const initialState: MarketStatusState = {
  isMarketOpen: false,
  isRepoOperationOpen: false,
  isHolidayToday: false,
  marketCanOperateT1Today: false,
  nextBusinessDay: "",
  followingBusinessDay: "",
};

const marketStatusSlice = createSlice({
  name: "marketStatus",
  initialState,
  reducers: {
    setMarketStatus(
      state,
      action: PayloadAction<{
        isMarketOpen: boolean;
        isRepoOperationOpen: boolean;
        isHolidayToday: boolean;
        marketCanOperateT1Today: boolean;
        nextBusinessDay: string;
        followingBusinessDay: string;
      }>,
    ) {
      state.isMarketOpen = action.payload.isMarketOpen;
      state.isRepoOperationOpen = action.payload.isRepoOperationOpen;
      state.isHolidayToday = action.payload.isHolidayToday;
      state.marketCanOperateT1Today = action.payload.marketCanOperateT1Today;
      state.nextBusinessDay = action.payload.nextBusinessDay;
      state.followingBusinessDay = action.payload.followingBusinessDay;
    },
  },
});

export const { setMarketStatus } = marketStatusSlice.actions;
export default marketStatusSlice.reducer;
